/* GANAS — Free-Shipping-Fortschrittsleiste.
   Wird global geladen (auch bei leerem Warenkorb), damit das Custom-Element
   immer definiert ist und sich bei jedem `cart:update` korrekt prozentual füllt. */
(function () {
  if (window.customElements && customElements.get('free-shipping-bar')) return;

  customElements.define(
    'free-shipping-bar',
    class extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.textEl = this.querySelector('[data-shipbar-text]');
        this.fillEl = this.querySelector('[data-shipbar-fill]');
        this.trackEl = this.querySelector('.tk-shipbar__track');
        this._onCartUpdate = this._onCartUpdate.bind(this);
        document.addEventListener('cart:update', this._onCartUpdate);
        // Immer einmal mit dem echten Warenkorbstand synchronisieren
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this._onCartUpdate);
      }

      _onCartUpdate(event) {
        var cart = event && event.detail && event.detail.resource;
        if (cart && typeof cart.total_price === 'number') {
          this.update(cart.total_price);
        } else {
          this.refresh();
        }
      }

      refresh() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { this.update(c.total_price); }.bind(this))
          .catch(function () {});
      }

      money(cents) {
        try {
          return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR',
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }
      }

      update(total) {
        if (!this.threshold) return;
        var remaining = this.threshold - total;
        var percent = Math.max(0, Math.min(100, (total / this.threshold) * 100));
        if (this.fillEl) this.fillEl.style.width = percent + '%';
        if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', Math.round(percent));
        if (this.textEl) {
          if (remaining > 0) {
            this.textEl.innerHTML =
              'Nur noch <strong>' + this.money(remaining) +
              '</strong> bis zum <strong>kostenlosen Versand</strong>!';
            this.classList.remove('tk-shipbar--reached');
          } else {
            this.textEl.innerHTML = 'Du erhältst kostenlosen Versand auf deine Bestellung!';
            this.classList.add('tk-shipbar--reached');
          }
        }
      }
    }
  );
})();
